/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientDisplayExportRequest } from '../models/ClientDisplayExportRequest';
import type { ExportFileResponse } from '../models/ExportFileResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingApplicationExcelReportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Export exactly what the client is currently displaying (new preferred path).
     * The client is responsible for all computed columns and formatting.
     * @param requestBody
     * @returns ExportFileResponse OK
     * @throws ApiError
     */
    public createReportFromDisplay(
        requestBody?: ClientDisplayExportRequest,
    ): CancelablePromise<ExportFileResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingApplicationExcelReport/CreateReportFromDisplay',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
